import { routerMiddleware } from 'connected-react-router';
import socketMiddleware from '../middleware/sockets.middleware';
import { applyMiddleware, compose, createStore } from 'redux';
import { createBrowserHistory } from 'history';

import thunk from 'redux-thunk';

import rootReducer from '../reducers/index';

export const history = createBrowserHistory();

const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export const store = createStore(
  rootReducer(history),
  composeEnhancers(
    applyMiddleware(socketMiddleware, routerMiddleware(history), thunk)
  )
);
export default store;
